import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect } from "react";

const JobApplication = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title={t('jobApp.heroTitle')}
        description={t('jobApp.heroSubtitle')}
        canonical="/job-application"
      />
      <Navbar />

      <main className="pb-20">
        {/* Hero Section */}
        <section className="text-center px-4 pt-28 pb-10 md:pt-44 md:pb-16">
          <div className="container mx-auto max-w-4xl">
            <h1 className="text-3xl md:text-5xl lg:text-7xl font-black text-navy-950 mb-6 tracking-tight uppercase">
              {t('jobApp.heroTitle')}
            </h1>
            <p className="text-xl md:text-2xl text-slate-600 font-medium max-w-2xl mx-auto">
              {t('jobApp.heroSubtitle')}
            </p>
          </div>
        </section>

        {/* Form Section */}
        <section className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden w-full">
            <iframe 
              className="clickup-embed clickup-dynamic-height" 
              src="https://forms.clickup.com/9017049670/f/8cqagj6-39537/3RQ1T1ZDZ6OUJ1F1Y7" 
              onWheel={() => {}} 
              width="100%" 
              height="100%" 
              style={{ background: 'transparent', border: 'none', width: '100%', minWidth: '100%' }}
            />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default JobApplication;
